import { QueryHookOptions, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { ApiError } from 'src/error';
import { LIST_PRODUCT_GROUP, ProductGroup } from 'src/graphql';

const useListProductGroup = (
  variables?: {
    type?: string | null;
    variableAttribute?: string | null;
  },
  options?: QueryHookOptions,
) => {
  const list = useQuery<{ productGroups: ProductGroup[] }>(LIST_PRODUCT_GROUP, {
    variables: variables,
    ...options,
  });

  const groups = useMemo(() => {
    if (!list.data) {
      return undefined;
    }

    // NOTE: When `variableAttribute` is provided, we're interested in groups
    // that are grouped by certain _other_ dimensions. This could change in the
    // future as the use case evolves.
    if (variables?.variableAttribute) {
      return list.data.productGroups.filter(
        group => group.group_ids.length > 0,
      );
    } else {
      return list.data.productGroups.filter(
        group => group.group_ids.length === 0,
      );
    }
  }, [list.data, variables?.variableAttribute]);

  if (list.error) {
    throw new ApiError(list.error.message);
  }
  
  return [groups, list] as const;
};

export default useListProductGroup;
